/** @format */

const ErrorMessage = ({ error, classes = 'f-14' }) => {
	if (!error) return null;
	return <div className={`text-danger ${classes}`}>{error}</div>;
};

export default ErrorMessage;
